export const uaeBanks = [
    "ADCB",
    "Emirates NBD",
    "RAK Bank",
    "First Abu Dhabi Bank",
    "Dubai Islamic Bank",
    "Emirates Islamic Bank",
    "Commercial Bank of Dubai",
    "Mashreq",
    "Mashreq Neo",
    "Liv",
]

export const sauBanks = [
    "Al Rajhi",
    "Alinma",
    "Arab National Bank",
    "Bank Al Bilad",
    "Banque Saudi Fransi",
    "Gulf Investment Bank",
    "Riyad Bank",
    "Saudi British Bank",
    "Saudi Investment Bank",
    "Saudi National Bank"
]